import Form from "react-bootstrap/Form";
import logo from "../assets/image/logo.png";
import { useLocation, useNavigate } from "react-router-dom";
import lock from "../assets/image/lock.png";
import eye from "../assets/image/eye.png";
import { Alert, Button } from "react-bootstrap";
import { useState } from "react";
import eye_off from "../assets/image/eye_off.png";
import { resetPassword } from "../service/authApi";
import { toast } from "react-toastify";
import SampleSlider from "../widget/Slider/SampleSlider";
import ReactLoading from "react-loading";

function ResetPassword() {
  const navigate = useNavigate();
  const [showpassword, setshowPassword] = useState(false);
  const [showpassword1, setshowPassword1] = useState(false);
  const location = useLocation();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [touched, setTouched] = useState({
    password: false,
    confirmPassword: false,
  });
  const userEmail = location?.state?.formdata;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setTouched({ password: true, confirmPassword: true });
    setLoader(true);
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
    } else if (!validatePassword(password)) {
      setError(
        "Password must be at least 8 characters, contain one digit, and one special character."
      );
    } else {
      setError(null);

      try {
        const payload = {
          email: userEmail,
          newPassword: password,
          confirmPassword: confirmPassword,
        };
        // eslint-disable-next-line no-unused-vars
        const resetPasword = await resetPassword(payload);

        toast.success(resetPasword.message, {
          autoClose: 5000,
        });
        setTimeout(() => {
          navigate("/", { state: { forgotPasswordCheck: true } });
        }, 1000);
      } catch (error) {
        console.log("error create pass", error);
      } finally {
        setTimeout(() => {
          setLoader(false);
        }, 3000);
      }
    }
  };
  const validatePassword = (password) => {
    const passwordRegex =
      /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/;
    return passwordRegex.test(password);
  };

  const isPasswordValid =
    password && confirmPassword && password === confirmPassword && !error;

  return (
    <>
      <div className="container-fluid bg-white custom-parent">
        <div style={{ minHeight: "100vh" }} className="row custom-row">
          <div className="col-lg-6 ">
            <SampleSlider />
          </div>
          <div className="col-lg-6">
            <div className="login-form">
              <div>
                <h2 className="pricebook" align="center">
                  Price Book
                </h2>
              </div>{" "}
              <div className="form_text">
                <div className="heading d-flex align-item-center">
                  <span></span>
                  <h1 className="main-heading">Reset Password</h1>
                </div>
                <p className="sub-heading mb-4">
                  Your new password must be different from previous used
                  password.
                </p>

                {error && (
                  <Alert variant="danger" className="mb-4">
                    {error}
                  </Alert>
                )}
                <Form onSubmit={handleSubmit}>
                  <div className="form-field">
                    <Form.Group className="mb-3" controlId="password">
                      <div className="position-relative">
                        <img
                          src={lock}
                          alt=""
                          className="left_icon position-absolute"
                        />
                        <Form.Control
                          type={showpassword ? "text" : "password"}
                          placeholder="Password"
                          className={`px-5 ${
                            touched.password &&
                            (error
                              ? "border-danger"
                              : isPasswordValid
                              ? ""
                              : "")
                          }`}
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          onFocus={() =>
                            setTouched((prev) => ({
                              ...prev,
                              password: true,
                            }))
                          }
                        />
                        <img
                          src={showpassword ? eye : eye_off}
                          alt=""
                          className="position-absolute right_icon"
                          onClick={() => setshowPassword(!showpassword)}
                        />
                      </div>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="confirmPassword">
                      <div className="position-relative">
                        <img
                          src={lock}
                          alt=""
                          className="left_icon position-absolute"
                        />
                        <Form.Control
                          type={showpassword1 ? "text" : "password"}
                          placeholder="Confirm Password"
                          className={`px-5 ${
                            touched.confirmPassword &&
                            (error ||
                              (password &&
                                confirmPassword &&
                                password !== confirmPassword))
                              ? "border-danger"
                              : isPasswordValid
                              ? ""
                              : ""
                          }`}
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          onFocus={() =>
                            setTouched((prev) => ({
                              ...prev,
                              confirmPassword: true,
                            }))
                          }
                        />
                        <img
                          src={showpassword1 ? eye : eye_off}
                          alt=""
                          className="position-absolute right_icon"
                          onClick={() => setshowPassword1(!showpassword1)}
                        />
                      </div>
                    </Form.Group>
                    <div className="d-grid gap-2 mb-4">
                      <Button
                        type="submit"
                        className="btn btn-success common-btn"
                        size="lg"
                      >
                        Create
                      </Button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
        {loader ? (
          <ReactLoading
            type={"bars"}
            color="#33995e"
            height={60}
            width={60}
            className={"globe_loader"}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default ResetPassword;
